import React from 'react';
import classNames from 'classnames';

interface SwitchProps {
	on: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
}

export default function Switch(props: SwitchProps) {
	const { on, onChange, className } = props;
	return (
		<div className={classNames("switch-wrapper", className)}>
			<label className={classNames("switch-container", { checked: on })}>
				<input type="checkbox" checked={on} onChange={onChange} />
			</label>
		</div>
	)
}